import { Card, Col, Flex, Row, Space, Tag, Typography } from 'antd';

export default function EquipmentCard({ equipment, onClick }) {
  return (
    <Card hoverable onClick={onClick}>
        <Typography>{equipment.name}</Typography>
    </Card>
  );
}
